module.exports = __webpack_public_path__ + "img/thank-you.43b4ba6f.svg";